exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SinglePersonView--title--ePzWxInO {\r\n  padding: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.SinglePersonView--title--ePzWxInO:hover {\r\n  background-color: lightgray;\r\n}\r\n\r\n.SinglePersonView--faulty--2E0DOL59 {\r\n  color: red;\r\n}", ""]);

// exports
exports.locals = {
	"title": "SinglePersonView--title--ePzWxInO",
	"faulty": "SinglePersonView--faulty--2E0DOL59"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/Beeper/Components/SinglePersonView.css
// module id = 975
// module chunks = 1